module.exports = __webpack_public_path__ + "media/src/fonts/icofont-dad3accba068281878f17175c6020940.woff";